<template>
    <div>
         <!-- About Section Start -->
    <div class="container">
        <div class="about_section pt-5 pb-0">

            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="500">
                    <h1 class="font-weight-bold mb-4 text-left">History</h1>
                    <div>
                        <h3 class="sub-title">It all started with a decision.</h3>
                        <p class="text-justify">Pratibha Group was established in 1982 with the formation of the Pratibha Fabrics Pvt Ltd which was established with the aim of processing polyester fabrics.<br />
Pratibha began to strengthen its position around 1990’s, gradually becoming a leading textile processing unit in Surat. As the company's foundation grew stronger, it expanded into several sectors of the industry, manufacturing various other varieties of fabrics and textile dyes.</p>
                    </div>
                </div>
            </div>


            <div class="row mt-5">
                <div class="col-12 col-sm-3 col-md-3 col-lg-3" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="400">
                    <div class="founder-w">
                        <img src="@/assets/images/paresh.png" />
                        <div class="founder-name">
                            <b>Paresh chaudhary</b><br />
                            Director
                        </div>
                    </div>

                </div>

                <div class="col-12 col-sm-3 col-md-3 col-lg-3" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="500">
                    <div class="founder-w">
                        <img src="@/assets/images/mahendra.png" />
                        <div class="founder-name">
                            <b>Mahendra chaudhary</b><br />
                            Chairman
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-3 col-md-3 col-lg-3" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="600">
                    <div class="founder-w">
                        <img src="@/assets/images/pramod.png" />
                        <div class="founder-name">
                            <b>Pramod chaudhary</b><br />
                            Chairman
                        </div>
                    </div>
                </div>

                <div class="col-12 col-sm-3 col-md-3 col-lg-3" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="700">
                    <div class="founder-w">
                        <img src="@/assets/images/akshat.png" />
                        <div class="founder-name">
                            <b>Akshat Chaudhary</b><br />
                            Director
                        </div>
                    </div>
                </div>

            </div>


            <div class="row mt-5">

                <div class="col-12 col-sm-7 col-md-7 col-lg-7">
                    <h3 class="sub-title mt-5">Diversifying</h3>
                    <p class="text-justify">In the decades that followed, the company expanded its product lines, established adjacent businesses, and even ventured into new textile products. Our extensive experience in high-quality textiles has enabled us to diversify into the production of textile fabrics, denim fabrics, linen fabrics, technical fabrics and textile dyes and chemicals.</p>
                </div>

                <div class="col-12 col-sm-5 col-md-5 col-lg-5">
                    <img src="@/assets/images/diversifying.png" />
                </div>

            </div>

        </div>






        <div class="about_section pt-0">

            <div class="row">
                <div class="col-12 col-sm-12 col-md-12 col-lg-12" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="700">
                    <h1 class="mb-4 text-left font-weight-bold">Values & Vision</h1>
                    <p class="mt-2">
                        Pratibha strives to be the global leader in the textile industry for manufacturing premium quality products by focusing on expanding product lines while keeping its customers in mind.
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 mt-5" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="600">
                    <div class="corporate-bg">
                        <h3 class="sub-title">Corporate ethics and responsibility</h3>
                        <p class="mt-2">
                            Pratibha is devoted to high corporate governance standards, commercial ethics, and transparency in all of the Company's operations. We are a company that immerses itself in cultural values and learns from the socio-economic realities of the communities in which it operates.

                        </p>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-5 col-lg-5 mt-5" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="700">
                    <div class="sense-bg">
                        <h3 class="sub-title">Sense of belonging and trust</h3>
                        <p class="mt-2">
                            Pratibha aspires to develop strong and long-term relationships with its stakeholders, fostering a sense of belonging to an exceptional company in which such stakeholders feel a vital part and a part of the strategy.
                            We inspire trust among all people who engage in and do business with it via continual communication.

                        </p>
                    </div>
                </div>
            </div>


            <div class="row">
                <div class="col-12 col-sm-12 col-md-5 col-lg-5 mt-4" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="600">
                    <div class="economic-bg">
                        <h3 class="sub-title">Economic results</h3>
                        <p class="mt-2">
                            Our dedication to attaining the growth and profitability targets outlined in the company's strategic plan is the method for ensuring the corporate strategy's success and meeting the demands and expectations of all group businesses participating in Pratibha's future. Within the framework of our diverse group, each business are subject to the Group's common policies, in the interest of Pratibha and all of its constituent firms.

                        </p>
                    </div>
                </div>
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 mt-4" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="700">
                    <div class="safety-bg">
                        <h3 class="sub-title">Safety and reliability</h3>
                        <p class="mt-2">
                            We strive to supply products and conduct our other activities in a safe and trustworthy environment. People's safety at our facilities, in neighboring areas, and among customers, as well as the development and distribution of best practices in the field of safety and prevention across the Group, are critical components of our entire operation.

                        </p>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-12 col-md-7 col-lg-7 mt-4" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="600">
                    <div class="respect-bg">
                        <h3 class="sub-title">Respect for the environment</h3>
                        <p class="mt-2">
                            The most essential founding pillar of Pratibha's buisness model and the features that distinguish us as a 21st-century organization is our focus on generating clean energy and environmentally friendly products and practices.

                        </p>
                    </div>
                </div>

                <div class="col-12 col-sm-12 col-md-5 col-lg-5 mt-4" data-aos="fade-up" data-aos-easing="linear" data-aos-duration="700">
                    <div class="customer-bg">
                        <h3 class="sub-title">Customer focus</h3>
                        <p class="mt-2">
                            We strive to understand our customers' requirements and expectations and work to continuously increase their level of satisfaction and connection to the company. our goal is to give the highest level of service while adhering to its regulatory duties.
                            The promises made by us in the Company's vision and values are more than just a set of ideas; they relate to everyday practice and are part of the Group's day-to-day management in all areas of operation.
                        </p>
                    </div>
                </div>
            </div>
        </div>


    </div>
    <!-- About Section End -->
    </div>
  </template>


  <script>

  // aos animation 
import AOS from 'aos'
import 'aos/dist/aos.css'
import 'animate.css/animate.min.css'

   export default {
            name: "about",
            created() {
            document.title = "About Us - Pratibha Group";
            },
            mounted() {
                this.init();
            },
            methods: {
                init() {
                    this.aosAnimation();
                },
                aosAnimation(){
                    AOS.init({
                        easing: 'ease-in-out-sine'
                    });
                }
            }
        
    }
  </script>